import api from 'services/api'

const Api = {
    get: () => api.get('/api/profile', {
        headers: { 'Content-Type': 'application/json' }
    })
}

export default Api
